<template>
  <div class="infor fl">
    <!-- 页头 -->
    <all-header
      :label="lable"
      :ischage="ischage"
      :sublabel="sublabel"
      :subtitle="subtitle"
      @getvalue="goBack"></all-header>

    <!-- 查询栏 -->
    <div class="cert-search">
      <div class="cert-search__left">
        <span class="cert-search__label">证书查询</span>
        <el-input
          v-model="keyword"
          placeholder="请输入关键词进行查询"
          class="cert-search__input"
          clearable
          @keyup.enter.native="onSearch"
        />
        <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
      </div>
      <div class="cert-search__right">
        <el-select v-model="year" placeholder="年份筛选" clearable size="mini" @change="onSearch">
          <el-option v-for="y in yearOptions" :key="y" :label="y" :value="y" />
        </el-select>
      </div>
    </div>

    <!-- 证书列表 -->
    <el-table
      :data="list"
      v-loading="loading"
      :header-cell-style="{ background: '#F3F6FF', color: '#7C828A' }"
      style="width: 100%; margin-top: 20px"
      empty-text="暂无证书"
    >
      <el-table-column label="证书编号" min-width="140" prop="certificate_no" />
      <el-table-column label="工程名称" min-width="220">
        <template slot-scope="{ row }">
          <span>{{ row.project_name || row.enterprise_name || '—' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="获取时间" min-width="110">
        <template slot-scope="{ row }">{{ row.display_issued_at || (row.issued_at ? row.issued_at.slice(0, 10) : '—') }}</template>
      </el-table-column>
      <el-table-column label="有效期至" min-width="110">
        <template slot-scope="{ row }">{{ row.valid_until ? row.valid_until.slice(0, 10) : '长期有效' }}</template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="220">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" :disabled="row.status !== 1 || !row.id" @click="onPreview(row)">获取证书</el-button>
          <el-button
            v-if="canViewGfText(row)"
            size="mini"
            type="text"
            @click="onViewGfText(row)"
          >工法文本</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pos-page">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        @current-change="onPageChange"
      />
    </div>

  </div>
</template>

<script>
import { CertificateList } from '../utils/api.js';
import AllHeader from './Modal/AllHeader.vue';

export default {
  name: 'Certificates',
  components: {
    AllHeader,
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      keyword: '',
      year: '',
      yearOptions: [],
      sublabel: '返回记录列表',
      subtitle: '',
      ischage: true,
      lable: '',
    };
  },
  mounted() {
    this.lable = this.$route.query.name || '荣誉证书';
    this.subtitle = this.$route.query.award_title || '';
    this.loadList();
  },
  methods: {
    async loadList() {
      this.loading = true;
      try {
        const res = await CertificateList({
          page: this.page,
          pageSize: this.pageSize,
          award_id: this.$route.query.award_id,
          keyword: this.keyword,
          year: this.year,
        });
        this.list = res.data || res;
        this.total = res.total || this.list.length;
        this.updateYearOptions();
      } catch (e) {
        this.$message.error('加载证书列表失败');
      } finally {
        this.loading = false;
      }
    },
    onPageChange(page) {
      this.page = page;
      this.loadList();
    },
    onPreview(cert) {
      this.$router.push({
        path: '/member/certificates/download',
        query: {
          cert_id: cert.id,
          award_id: this.$route.query.award_id,
          award_title: this.$route.query.award_title,
          name: this.$route.query.name || '荣誉证书明细',
        },
      });
    },
    onViewGfText(cert) {
      const url = this.getGfTextUrl(cert);
      if (!url) {
        this.$message.warning('暂无可查看的工法文本');
        return;
      }
      window.open(url, '_blank');
    },
    canViewGfText(cert) {
      return this.isGfCertificate(cert)
        && this.isAuthorized(this.pickField(cert, [
          'text_public_authorized',
          'gf_text_authorized',
          'textPublicAuthorized',
          'award_log.text_public_authorized',
          'award_log.gf_text_authorized',
          'content.info.text_public_authorized',
          'content.info.gf_text_authorized',
        ]))
        && !!this.getGfTextUrl(cert);
    },
    isGfCertificate(cert) {
      const awardId = Number(this.$route.query.award_id || cert.award_id || cert.awardid);
      const title = [
        this.$route.query.award_title,
        cert.award_title,
        cert.award_name,
        cert.type_name,
      ].filter(Boolean).join('');
      return awardId === 21 || title.indexOf('工法') !== -1;
    },
    getGfTextUrl(cert) {
      const file = this.pickField(cert, [
        'gf_text_url',
        'text_file_url',
        'award_log.content.info.filelist4.0.url',
        'content.info.filelist4.0.url',
        'info.filelist4.0.url',
        'filelist4.0.url',
      ]);
      return typeof file === 'string' ? file : '';
    },
    isAuthorized(value) {
      return value === true || value === 1 || value === '1';
    },
    pickField(source, paths) {
      for (const path of paths) {
        const value = path.split('.').reduce((target, key) => {
          if (target === undefined || target === null) {
            return undefined;
          }
          return target[key];
        }, source);
        if (value !== undefined && value !== null && value !== '') {
          return value;
        }
      }
      return undefined;
    },
    onSearch() {
      this.page = 1;
      this.loadList();
    },
    updateYearOptions() {
      const years = new Set();
        this.list.forEach(item => {
        const issueDate = item.display_issued_at || item.issued_at;
        if (issueDate) {
          years.add(issueDate.slice(0, 4));
        }
      });
      this.yearOptions = Array.from(years).sort((a, b) => b - a);
    },
    goBack() {
      this.$router.push('/member/Declar_record?name=申报记录');
    },
  },
};
</script>

<style lang="less" scoped>
.infor-t-r {
  padding: 6px 14px;
  border: 1px solid #5d8dff;
  color: #5d8dff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
}

.cert-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 14px;
  padding: 10px 12px;
  background: #f6f8ff;
  border-radius: 6px;
}

.cert-search__left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cert-search__label {
  color: #666;
  font-size: 13px;
}

.cert-search__input {
  width: 260px;
}

.cert-search__right {
  display: flex;
  align-items: center;
}
</style>
.infor {
  &-t {
    height: 55px;
    line-height: 55px;
    border-bottom: 1px solid #f0f0f0;
    &-l {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }
}
.pos-page {
  margin-top: 20px;
  text-align: center;
}
.download-form {
  padding: 0 10px;
}
</style>
